import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./en";
import arTranslation from "./ar";

i18next.use(initReactI18next).init({
  lng: "en", // Will be overridden by language detection
  fallbackLng: "en",
  debug: process.env.NODE_ENV === "development",
  resources: {
    en: { translation: enTranslation },
    ar: { translation: arTranslation },
  },
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["path", "cookie", "htmlTag"],
    caches: ["cookie"],
  },
});
